import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { NgxPaginationModule } from 'ngx-pagination'
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxSocialShareModule } from 'ngx-social-share';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './lock/footer/footer.component';
import { MenuNavComponent } from './lock/menu-nav/menu-nav.component';
import { IndexComponent } from './main/index/index.component';
import { QuienesSomosComponent } from './main/quienes-somos/quienes-somos.component';
import { ServiciosComponent } from './main/servicios/servicios.component';
import { SaludComponent } from './main/salud/salud.component';
import { EstadisticasComponent } from './main/estadisticas/estadisticas.component';
import { ConsultasPorEstadoComponent } from './main/consultas-por-estado/consultas-por-estado.component';
import { SimposiosComponent } from './main/simposios/simposios.component';
import { SimposioComponent } from './main/simposio/simposio.component';
import { NotasComponent } from './main/notas/notas.component';
import { NotaComponent } from './main/nota/nota.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DirectorioComponent } from './main/directorio/directorio.component';
import { ContactoComponent } from './main/contacto/contacto.component';
import { EmpleoComponent } from './main/empleo/empleo.component';
import { AvisoDePrivacidadComponent } from './main/aviso-de-privacidad/aviso-de-privacidad.component';
import { AvisoLegalComponent } from './main/aviso-legal/aviso-legal.component';
import { ConsultoriosComponent } from './main/consultorios/consultorios.component';
import { ConsultoriosDentalesComponent } from './main/consultorios-dentales/consultorios-dentales.component';
import { LigasGrupoPorUnPaisMejorComponent } from './main/ligas-grupo-por-un-pais-mejor/ligas-grupo-por-un-pais-mejor.component';
import { ConsultoriosNutricionalesComponent } from './main/consultorios-nutricionales/consultorios-nutricionales.component';
import { LigasSaludComponent } from './main/ligas-salud/ligas-salud.component';
import { RegistroComponent } from './main/licitaciones/registro/registro.component';
import { LoginComponent } from './main/licitaciones/login/login.component';
import { ListadoOfertasComponent } from './main/licitaciones/listado-ofertas/listado-ofertas.component';
import { ListadoProveedorComponent } from './main/licitaciones/listado-proveedor/listado-proveedor.component';
import { ActualizacionRegistroComponent } from './main/licitaciones/actualizacion-registro/actualizacion-registro.component';
import { ActualizacionContrasenaComponent } from './main/licitaciones/actualizacion-contrasena/actualizacion-contrasena.component';
import { RecuperarContrasenaComponent } from './main/licitaciones/recuperar-contrasena/recuperar-contrasena.component';
import { FamiliasComponent } from './main/licitaciones/administrador/familias/familias.component';
import { CalificacionComponent } from './main/licitaciones/administrador/calificacion/calificacion.component';
import { OfertasDeLicitacionComponent } from './main/licitaciones/administrador/ofertas-de-licitacion/ofertas-de-licitacion.component';
import { ConsultasReportesComponent } from './main/licitaciones/administrador/consultas-reportes/consultas-reportes.component'
import { PostulanteslicitacionComponent } from './main/licitaciones/administrador/postulanteslicitacion/postulanteslicitacion.component'
import { LoginAdminComponent } from './main/licitaciones/administrador/login-admin/login-admin.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ConsultoriosPsicologicosComponent } from './main/consultorios-psicologicos/consultorios-psicologicos.component';
import { ConsultoriosEspecialidadesComponent } from './main/consultorios-especialidades/consultorios-especialidades.component'
import { CookiesComponent } from './main/cookies/cookies.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MenuNavComponent,
    IndexComponent,
    QuienesSomosComponent,
    ServiciosComponent,
    SaludComponent,
    EstadisticasComponent,
    ConsultasPorEstadoComponent,
    SimposiosComponent,
    SimposioComponent,
    NotasComponent,
    NotaComponent,
    DirectorioComponent,
    ContactoComponent,
    EmpleoComponent,
    AvisoDePrivacidadComponent,
    AvisoLegalComponent,
    ConsultoriosComponent,
    ConsultoriosDentalesComponent,
    LigasGrupoPorUnPaisMejorComponent,
    ConsultoriosNutricionalesComponent,
    LigasSaludComponent,
    RegistroComponent,
    LoginComponent,
    ListadoOfertasComponent,
    ListadoProveedorComponent,
    ActualizacionRegistroComponent,
    ActualizacionContrasenaComponent,
    RecuperarContrasenaComponent,
    FamiliasComponent,
    CalificacionComponent,
    OfertasDeLicitacionComponent,
    ConsultasReportesComponent,
    LoginAdminComponent,
    PostulanteslicitacionComponent,
    ConsultoriosPsicologicosComponent,
    ConsultoriosEspecialidadesComponent,
    CookiesComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'fundacion-best2021' }),
    AppRoutingModule,
    NgxPaginationModule,
    NgxPaginationModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSocialShareModule,
    CarouselModule.forRoot(),
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
